import React from 'react';

import { IIconProps, TIconType } from '../interface';

const LayerIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-id='icon-button'
			data-testid='layer'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M3 16.5L12 21.75L21 16.5'
				data-id='icon-button'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
				{...props?.innerSvgProps}
			/>
			<path
				d='M3 12L12 17.25L21 12'
				data-id='icon-button'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
				{...props?.innerSvgProps}
			/>
			<path
				d='M3 7.5L12 12.75L21 7.5L12 2.25L3 7.5Z'
				data-id='icon-button'
				fill='currentColor'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
				{...props?.innerSvgProps}
			/>
		</svg>
	);
};

export default LayerIcon;
